import { render, staticRenderFns } from "./04zhihuiwenlv.vue?vue&type=template&id=28d37ac3&scoped=true&"
import script from "./04zhihuiwenlv.vue?vue&type=script&lang=js&"
export * from "./04zhihuiwenlv.vue?vue&type=script&lang=js&"
import style0 from "./04zhihuiwenlv.vue?vue&type=style&index=0&id=28d37ac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d37ac3",
  null
  
)

export default component.exports